import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const PlaidErrorModal = (props) => {
    const { doneButton } = usePageMessages();

    const capitalizeFirstLetter = (string) => {
        return string[0].toUpperCase() + string.slice(1);
    };

    return (
        <ModalComponent canCloseModal={false} isVerticalCentered>
            <InfoPage
                insideModalComponent={false}
                animatedIconFail
                headerText={capitalizeFirstLetter(props.errorText)}
                primaryButtonType="link"
                primaryButtonCaption={doneButton}
                primaryButtonOnClick={() => {
                    props.toggleSpinner(true);
                    window.location.href = AUTH_SEND_MAIN_LINK;
                }}
            />
        </ModalComponent>
    );
};
export default connect(null, { toggleSpinner })(PlaidErrorModal);
